<template>
  <v-card>
    <v-list class="list--table py-0">
      <v-list-tile
        v-if="!isMobile"
        class="primary white--text py-1"
      >
        <v-layout>
          <v-flex
            md6
            class="px-2 py-1 body-2"
          >自動車メーカー[年式]</v-flex>
          <v-flex
            md3
            class="px-2 py-1 body-2"
          >顧客</v-flex>
          <v-flex
            md2
            class="px-2 py-1 body-2"
          >電話番号</v-flex>
          <v-flex
            md2
            class="px-2 py-1 body-2"
          >訪問日</v-flex>
          <v-flex
            md3
            class="px-2 py-1 body-2"
          >マイページステップ</v-flex>
        </v-layout>
      </v-list-tile>
      <template v-for="(appointment, i) in appointments">
        <v-divider
          v-if="!!i"
          :key="id(appointment) + '_divider'"
        />
        <v-list-tile
          :key="id(appointment)"
          tag="div"
          class="py-3 appointment-list-item"
          @click="onClick(appointment)"
        >
          <v-layout align-center>
            <v-flex>
              <v-layout :column="isMobile">
                <v-flex
                  md6
                  class="px-2 py-1 body-2 primary--text"
                >
                  {{ title(appointment) }}
                  <div
                    :class="idClass(appointment)">
                    {{ formatId(appointment) }}
                  </div>
                </v-flex>
                <v-flex
                  v-if="appointment.lastName"
                  md3
                  class="px-2 py-1 body-1"
                >
                  {{ appointment.lastName }}{{ appointment.name }}
                </v-flex>
                <v-flex
                  v-else
                  md3
                  class="px-2 py-1 body-1"
                >
                  {{ appointment.furiganaLastName }}{{ appointment.furiganaLame }}
                </v-flex>
                <v-flex
                  v-if="!isMobile"
                  md2
                  class="px-2 py-1 body-1"
                  style="min-height: 40px"
                >
                  <hidden-text
                    v-if="appointment.phone"
                    :text="formatPhone(appointment.phone)" />
                </v-flex>
                <v-flex
                  md2
                  class="px-2 py-1 body-1"
                >{{ formatDate(appointment.appointment.time) }}</v-flex>
                <v-flex
                  md3
                  class="px-2 py-1 step-font-size"
                >{{ formatStep(
                  appointment.appointment.clientCabinetWorkflow.step,
                  isMobile) }}
                </v-flex>
              </v-layout>
            </v-flex>
            <v-flex
              v-if="isMobile"
              xs-2
              class="text-xs-right"
            >
              <router-link :to="inspectionRoute(appointment)">
                <v-icon
                  color="primary"
                  x-large
                >chevron_right</v-icon>
              </router-link>
            </v-flex>
          </v-layout>
        </v-list-tile>
      </template>
      <v-list-tile
        v-if="!appointments.length"
        class="py-1"
      >
        <v-flex class="text-xs-center">この検索結果では何もありませんでした</v-flex>
      </v-list-tile>
    </v-list>
  </v-card>
</template>

<style scoped lang="scss">
a {
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

.caption {
  color: grey;
}
.self-ins {
  font-size: 12px;
  margin-left: -6px;
  color: #3949AB;
}
.cancel {
  font-size: 12px;
  margin-left: -6px;
  color: red;
}
.step-font-size {
  font-size: 13px;
}

</style>
<script>
import HiddenText from './elements/HiddenText';
import { stepById } from '../options';
import { isCancelInspection } from '../cancelInspection';

export default {
  components: {
    HiddenText,
  },
  props: {
    appointments: {
      type: Array,
      default: () => [],
    },
    serverTime: {
      type: Number,
      default: 0,
    },
  },
  methods: {
    id({ appointment }) {
      return appointment.id;
    },
    formatId({ appointment }) {
      const { id, selfInspectionFlag, status, dateCreate } = appointment;
      if (isCancelInspection(status, dateCreate, this.serverTime)) return `【キャンセル】${id}`;

      return parseInt(selfInspectionFlag, 10) ? `【セルフ】${id}` : id;
    },
    idClass({ appointment }) {
      const { selfInspectionFlag, status, dateCreate } = appointment;
      if (isCancelInspection(status, dateCreate, this.serverTime)) return 'cancel mt-3';

      return parseInt(selfInspectionFlag, 10) ? 'self-ins mt-3' : 'caption mt-3';
    },
    inspectionRoute({ appointment }) {
      const path = this.getNextPath(appointment);
      return path ? { path } : '';
    },
    title({ appointment }) {
      const { car } = appointment;

      if (!car) return '';

      return car.title || '';
    },
    formatDate(value) {
      if (!value) {
        return '';
      }

      return value.slice(5, -3).replace('-', '月').replace(' ', '日 ');
    },
    formatPhone(value) {
      if (!value) {
        return '';
      }
      return value.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
    },
    formatStep(value, isMobile) {
      if (!value) {
        return '';
      }
      const mobile = isMobile ? 'マイページステップ：' : '';
      const step = stepById(value);
      return step ? `${mobile}${step.value}` : '';
    },
    onClick({ appointment }) {
      const path = this.getNextPath(appointment);
      return path ? this.$router.push(path) : null;
    },
    getNextPath(appointment) {
      const { id, selfInspectionFlag, clientCabinetWorkflow } = appointment;
      const path = `/inspection/${id}/owner`;

      if (parseInt(selfInspectionFlag, 10)) {
        const selfCompStep = stepById('SelfInspection.Complete');
        const currentStep = stepById(clientCabinetWorkflow.step);
        return (currentStep && currentStep.order >= selfCompStep.order) ? path : null;
      }
      return path;
    },
  },
};
</script>

<style lang="scss">
.appointment-list-item {
  .v-list__tile {
    height: auto !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppointmentsList.vue